/* tslint:disable */
/* eslint-disable */
/**
 * ahoy
 * Worlds next gen CRM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DemoModeStatusResponse,
  DemoModeToggleRequest,
  DemoModeToggleResponse,
  DemoRefreshRequest,
  DemoRefreshResponse,
  DemoRefreshStatusResponse,
  EmailTrackingStatusResponse,
  EmailTrackingToggleRequest,
  EmailTrackingToggleResponse,
  FeatureFlagsResponse,
  Invitation,
  InvitationAcceptResponse,
  InvitationDetailResponse,
  InvitationPrepareOAuthResponse,
  OrgFlagToggleResponse,
  OrgFlagsListResponse,
  OrgUsageResponse,
  OrgUser,
  PaginatedInvitationList,
  PatchedInvitation,
  UserInvitationsResponse,
} from '../models/index';
import {
    DemoModeStatusResponseFromJSON,
    DemoModeStatusResponseToJSON,
    DemoModeToggleRequestFromJSON,
    DemoModeToggleRequestToJSON,
    DemoModeToggleResponseFromJSON,
    DemoModeToggleResponseToJSON,
    DemoRefreshRequestFromJSON,
    DemoRefreshRequestToJSON,
    DemoRefreshResponseFromJSON,
    DemoRefreshResponseToJSON,
    DemoRefreshStatusResponseFromJSON,
    DemoRefreshStatusResponseToJSON,
    EmailTrackingStatusResponseFromJSON,
    EmailTrackingStatusResponseToJSON,
    EmailTrackingToggleRequestFromJSON,
    EmailTrackingToggleRequestToJSON,
    EmailTrackingToggleResponseFromJSON,
    EmailTrackingToggleResponseToJSON,
    FeatureFlagsResponseFromJSON,
    FeatureFlagsResponseToJSON,
    InvitationFromJSON,
    InvitationToJSON,
    InvitationAcceptResponseFromJSON,
    InvitationAcceptResponseToJSON,
    InvitationDetailResponseFromJSON,
    InvitationDetailResponseToJSON,
    InvitationPrepareOAuthResponseFromJSON,
    InvitationPrepareOAuthResponseToJSON,
    OrgFlagToggleResponseFromJSON,
    OrgFlagToggleResponseToJSON,
    OrgFlagsListResponseFromJSON,
    OrgFlagsListResponseToJSON,
    OrgUsageResponseFromJSON,
    OrgUsageResponseToJSON,
    OrgUserFromJSON,
    OrgUserToJSON,
    PaginatedInvitationListFromJSON,
    PaginatedInvitationListToJSON,
    PatchedInvitationFromJSON,
    PatchedInvitationToJSON,
    UserInvitationsResponseFromJSON,
    UserInvitationsResponseToJSON,
} from '../models/index';

export interface DemoModeStatusRequest {
    orgId: number;
}

export interface DemoModeToggleOperationRequest {
    orgId: number;
    demoModeToggleRequest: DemoModeToggleRequest;
}

export interface DemoRefreshOperationRequest {
    orgId: number;
    demoRefreshRequest?: DemoRefreshRequest;
}

export interface DemoRefreshStatusRequest {
    orgId: number;
    taskId: string;
}

export interface EmailTrackingStatusRequest {
    orgId: number;
}

export interface EmailTrackingToggleOperationRequest {
    orgId: number;
    emailTrackingToggleRequest: EmailTrackingToggleRequest;
}

export interface InvitationAcceptRequest {
    invitationId: string;
}

export interface InvitationDetailRequest {
    invitationId: string;
}

export interface InvitationPrepareOauthRequest {
    invitationId: string;
}

export interface InvitationsCreateRequest {
    orgId: number;
    invitation: Omit<Invitation, 'id'|'invited_by'>;
}

export interface InvitationsCreate2Request {
    orgId: number;
    invitation: Omit<Invitation, 'id'|'invited_by'>;
}

export interface InvitationsDestroyRequest {
    id: string;
    orgId: number;
}

export interface InvitationsDestroy2Request {
    id: string;
    orgId: number;
}

export interface InvitationsListRequest {
    orgId: number;
    page?: number;
    pageSize?: number;
}

export interface InvitationsList2Request {
    orgId: number;
    page?: number;
    pageSize?: number;
}

export interface InvitationsPartialUpdateRequest {
    id: string;
    orgId: number;
    patchedInvitation?: Omit<PatchedInvitation, 'id'|'invited_by'>;
}

export interface InvitationsPartialUpdate2Request {
    id: string;
    orgId: number;
    patchedInvitation?: Omit<PatchedInvitation, 'id'|'invited_by'>;
}

export interface InvitationsRetrieveRequest {
    id: string;
    orgId: number;
}

export interface InvitationsRetrieve2Request {
    id: string;
    orgId: number;
}

export interface InvitationsUpdateRequest {
    id: string;
    orgId: number;
    invitation: Omit<Invitation, 'id'|'invited_by'>;
}

export interface InvitationsUpdate2Request {
    id: string;
    orgId: number;
    invitation: Omit<Invitation, 'id'|'invited_by'>;
}

export interface OrgFeatureFlagsRequest {
    orgId: number;
}

export interface OrgFlagToggleRequest {
    flagName: string;
    orgId: number;
}

export interface OrgFlagsListRequest {
    orgId: number;
}

export interface OrgUsageRequest {
    orgId: number;
}

export interface TeamUsersListRequest {
    orgId: number;
}

/**
 * 
 */
export class TeamsApi extends runtime.BaseAPI {

    /**
     * API endpoint to toggle demo mode (is_demo) on an organization.  POST: Sets or clears the is_demo flag on org.metadata. Internal (@ahoy.ai) users only.
     */
    async demoModeStatusRaw(requestParameters: DemoModeStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DemoModeStatusResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling demoModeStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/demo-mode/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DemoModeStatusResponseFromJSON(jsonValue));
    }

    /**
     * API endpoint to toggle demo mode (is_demo) on an organization.  POST: Sets or clears the is_demo flag on org.metadata. Internal (@ahoy.ai) users only.
     */
    async demoModeStatus(requestParameters: DemoModeStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DemoModeStatusResponse> {
        const response = await this.demoModeStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint to toggle demo mode (is_demo) on an organization.  POST: Sets or clears the is_demo flag on org.metadata. Internal (@ahoy.ai) users only.
     */
    async demoModeToggleRaw(requestParameters: DemoModeToggleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DemoModeToggleResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling demoModeToggle().'
            );
        }

        if (requestParameters['demoModeToggleRequest'] == null) {
            throw new runtime.RequiredError(
                'demoModeToggleRequest',
                'Required parameter "demoModeToggleRequest" was null or undefined when calling demoModeToggle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/demo-mode/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DemoModeToggleRequestToJSON(requestParameters['demoModeToggleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DemoModeToggleResponseFromJSON(jsonValue));
    }

    /**
     * API endpoint to toggle demo mode (is_demo) on an organization.  POST: Sets or clears the is_demo flag on org.metadata. Internal (@ahoy.ai) users only.
     */
    async demoModeToggle(requestParameters: DemoModeToggleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DemoModeToggleResponse> {
        const response = await this.demoModeToggleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint to refresh demo data for an organization.  POST: Triggers demo data refresh and returns navigation data.  For personalized demo refresh (which can take 2+ minutes due to Claude/Tavily), returns a task_id for polling. Non-personalized refresh runs synchronously.
     */
    async demoRefreshRaw(requestParameters: DemoRefreshOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DemoRefreshResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling demoRefresh().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/demo-refresh/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DemoRefreshRequestToJSON(requestParameters['demoRefreshRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DemoRefreshResponseFromJSON(jsonValue));
    }

    /**
     * API endpoint to refresh demo data for an organization.  POST: Triggers demo data refresh and returns navigation data.  For personalized demo refresh (which can take 2+ minutes due to Claude/Tavily), returns a task_id for polling. Non-personalized refresh runs synchronously.
     */
    async demoRefresh(requestParameters: DemoRefreshOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DemoRefreshResponse> {
        const response = await this.demoRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint to check the status of an async demo refresh task.  GET: Returns the current status and result of the task.
     */
    async demoRefreshStatusRaw(requestParameters: DemoRefreshStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DemoRefreshStatusResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling demoRefreshStatus().'
            );
        }

        if (requestParameters['taskId'] == null) {
            throw new runtime.RequiredError(
                'taskId',
                'Required parameter "taskId" was null or undefined when calling demoRefreshStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/demo-refresh/{task_id}/status/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))).replace(`{${"task_id"}}`, encodeURIComponent(String(requestParameters['taskId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DemoRefreshStatusResponseFromJSON(jsonValue));
    }

    /**
     * API endpoint to check the status of an async demo refresh task.  GET: Returns the current status and result of the task.
     */
    async demoRefreshStatus(requestParameters: DemoRefreshStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DemoRefreshStatusResponse> {
        const response = await this.demoRefreshStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint to read and toggle email tracking for an organization.  GET: Returns the current email_tracking_enabled setting. POST: Sets the email_tracking_enabled flag on org.metadata. Requires org membership and ahoy_other_admin permission group.
     */
    async emailTrackingStatusRaw(requestParameters: EmailTrackingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailTrackingStatusResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling emailTrackingStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/email-tracking/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailTrackingStatusResponseFromJSON(jsonValue));
    }

    /**
     * API endpoint to read and toggle email tracking for an organization.  GET: Returns the current email_tracking_enabled setting. POST: Sets the email_tracking_enabled flag on org.metadata. Requires org membership and ahoy_other_admin permission group.
     */
    async emailTrackingStatus(requestParameters: EmailTrackingStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailTrackingStatusResponse> {
        const response = await this.emailTrackingStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * API endpoint to read and toggle email tracking for an organization.  GET: Returns the current email_tracking_enabled setting. POST: Sets the email_tracking_enabled flag on org.metadata. Requires org membership and ahoy_other_admin permission group.
     */
    async emailTrackingToggleRaw(requestParameters: EmailTrackingToggleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmailTrackingToggleResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling emailTrackingToggle().'
            );
        }

        if (requestParameters['emailTrackingToggleRequest'] == null) {
            throw new runtime.RequiredError(
                'emailTrackingToggleRequest',
                'Required parameter "emailTrackingToggleRequest" was null or undefined when calling emailTrackingToggle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/email-tracking/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: EmailTrackingToggleRequestToJSON(requestParameters['emailTrackingToggleRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmailTrackingToggleResponseFromJSON(jsonValue));
    }

    /**
     * API endpoint to read and toggle email tracking for an organization.  GET: Returns the current email_tracking_enabled setting. POST: Sets the email_tracking_enabled flag on org.metadata. Requires org membership and ahoy_other_admin permission group.
     */
    async emailTrackingToggle(requestParameters: EmailTrackingToggleOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmailTrackingToggleResponse> {
        const response = await this.emailTrackingToggleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Accept an invitation (requires authentication)
     */
    async invitationAcceptRaw(requestParameters: InvitationAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationAcceptResponse>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling invitationAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/invitations/{invitation_id}/`.replace(`{${"invitation_id"}}`, encodeURIComponent(String(requestParameters['invitationId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationAcceptResponseFromJSON(jsonValue));
    }

    /**
     * Accept an invitation (requires authentication)
     */
    async invitationAccept(requestParameters: InvitationAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationAcceptResponse> {
        const response = await this.invitationAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get invitation details by ID (doesn\'t require authentication)
     */
    async invitationDetailRaw(requestParameters: InvitationDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationDetailResponse>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling invitationDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/invitations/{invitation_id}/`.replace(`{${"invitation_id"}}`, encodeURIComponent(String(requestParameters['invitationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationDetailResponseFromJSON(jsonValue));
    }

    /**
     * Get invitation details by ID (doesn\'t require authentication)
     */
    async invitationDetail(requestParameters: InvitationDetailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationDetailResponse> {
        const response = await this.invitationDetailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Prepare OAuth flow by storing invitation ID in session. This endpoint is called before initiating OAuth to preserve invitation context. No authentication required.
     */
    async invitationPrepareOauthRaw(requestParameters: InvitationPrepareOauthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationPrepareOAuthResponse>> {
        if (requestParameters['invitationId'] == null) {
            throw new runtime.RequiredError(
                'invitationId',
                'Required parameter "invitationId" was null or undefined when calling invitationPrepareOauth().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/invitations/{invitation_id}/`.replace(`{${"invitation_id"}}`, encodeURIComponent(String(requestParameters['invitationId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationPrepareOAuthResponseFromJSON(jsonValue));
    }

    /**
     * Prepare OAuth flow by storing invitation ID in session. This endpoint is called before initiating OAuth to preserve invitation context. No authentication required.
     */
    async invitationPrepareOauth(requestParameters: InvitationPrepareOauthRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationPrepareOAuthResponse> {
        const response = await this.invitationPrepareOauthRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsCreateRaw(requestParameters: InvitationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsCreate().'
            );
        }

        if (requestParameters['invitation'] == null) {
            throw new runtime.RequiredError(
                'invitation',
                'Required parameter "invitation" was null or undefined when calling invitationsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{org_id}/team/api/invitations/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvitationToJSON(requestParameters['invitation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsCreate(requestParameters: InvitationsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsCreate2Raw(requestParameters: InvitationsCreate2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsCreate2().'
            );
        }

        if (requestParameters['invitation'] == null) {
            throw new runtime.RequiredError(
                'invitation',
                'Required parameter "invitation" was null or undefined when calling invitationsCreate2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/invitations/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InvitationToJSON(requestParameters['invitation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsCreate2(requestParameters: InvitationsCreate2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsCreate2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsDestroyRaw(requestParameters: InvitationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsDestroy().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{org_id}/team/api/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsDestroy(requestParameters: InvitationsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invitationsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsDestroy2Raw(requestParameters: InvitationsDestroy2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsDestroy2().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsDestroy2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsDestroy2(requestParameters: InvitationsDestroy2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.invitationsDestroy2Raw(requestParameters, initOverrides);
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsListRaw(requestParameters: InvitationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInvitationList>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{org_id}/team/api/invitations/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInvitationListFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsList(requestParameters: InvitationsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInvitationList> {
        const response = await this.invitationsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsList2Raw(requestParameters: InvitationsList2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedInvitationList>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsList2().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/invitations/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedInvitationListFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsList2(requestParameters: InvitationsList2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedInvitationList> {
        const response = await this.invitationsList2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsPartialUpdateRaw(requestParameters: InvitationsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsPartialUpdate().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{org_id}/team/api/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedInvitationToJSON(requestParameters['patchedInvitation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsPartialUpdate(requestParameters: InvitationsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsPartialUpdate2Raw(requestParameters: InvitationsPartialUpdate2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsPartialUpdate2().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsPartialUpdate2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedInvitationToJSON(requestParameters['patchedInvitation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsPartialUpdate2(requestParameters: InvitationsPartialUpdate2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsPartialUpdate2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsRetrieveRaw(requestParameters: InvitationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsRetrieve().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{org_id}/team/api/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsRetrieve(requestParameters: InvitationsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsRetrieve2Raw(requestParameters: InvitationsRetrieve2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsRetrieve2().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsRetrieve2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsRetrieve2(requestParameters: InvitationsRetrieve2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsRetrieve2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsUpdateRaw(requestParameters: InvitationsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsUpdate().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsUpdate().'
            );
        }

        if (requestParameters['invitation'] == null) {
            throw new runtime.RequiredError(
                'invitation',
                'Required parameter "invitation" was null or undefined when calling invitationsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/a/{org_id}/team/api/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvitationToJSON(requestParameters['invitation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsUpdate(requestParameters: InvitationsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsUpdate2Raw(requestParameters: InvitationsUpdate2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Invitation>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling invitationsUpdate2().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling invitationsUpdate2().'
            );
        }

        if (requestParameters['invitation'] == null) {
            throw new runtime.RequiredError(
                'invitation',
                'Required parameter "invitation" was null or undefined when calling invitationsUpdate2().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/invitations/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InvitationToJSON(requestParameters['invitation']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationFromJSON(jsonValue));
    }

    /**
     * Mixin that provides access to the org from request (set by TeamsMiddleware). Validates that the org exists and the user is a member.
     */
    async invitationsUpdate2(requestParameters: InvitationsUpdate2Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Invitation> {
        const response = await this.invitationsUpdate2Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get active feature flags for an org.  Scale: O(flags) with no N+1 queries due to prefetch_related. Iterates all flags without pagination. Acceptable for typical flag counts <100. flag_is_active() is an in-memory check (no additional queries).
     */
    async orgFeatureFlagsRaw(requestParameters: OrgFeatureFlagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FeatureFlagsResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling orgFeatureFlags().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/feature-flags/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FeatureFlagsResponseFromJSON(jsonValue));
    }

    /**
     * Get active feature flags for an org.  Scale: O(flags) with no N+1 queries due to prefetch_related. Iterates all flags without pagination. Acceptable for typical flag counts <100. flag_is_active() is an in-memory check (no additional queries).
     */
    async orgFeatureFlags(requestParameters: OrgFeatureFlagsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FeatureFlagsResponse> {
        const response = await this.orgFeatureFlagsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Toggle a feature flag for this org.
     */
    async orgFlagToggleRaw(requestParameters: OrgFlagToggleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgFlagToggleResponse>> {
        if (requestParameters['flagName'] == null) {
            throw new runtime.RequiredError(
                'flagName',
                'Required parameter "flagName" was null or undefined when calling orgFlagToggle().'
            );
        }

        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling orgFlagToggle().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/flags/{flag_name}/toggle/`.replace(`{${"flag_name"}}`, encodeURIComponent(String(requestParameters['flagName']))).replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgFlagToggleResponseFromJSON(jsonValue));
    }

    /**
     * Toggle a feature flag for this org.
     */
    async orgFlagToggle(requestParameters: OrgFlagToggleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgFlagToggleResponse> {
        const response = await this.orgFlagToggleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all feature flags with their enabled state for this org.
     */
    async orgFlagsListRaw(requestParameters: OrgFlagsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgFlagsListResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling orgFlagsList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/flags/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgFlagsListResponseFromJSON(jsonValue));
    }

    /**
     * List all feature flags with their enabled state for this org.
     */
    async orgFlagsList(requestParameters: OrgFlagsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgFlagsListResponse> {
        const response = await this.orgFlagsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Return usage statistics for the organization.
     */
    async orgUsageRaw(requestParameters: OrgUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OrgUsageResponse>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling orgUsage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/usage/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OrgUsageResponseFromJSON(jsonValue));
    }

    /**
     * Return usage statistics for the organization.
     */
    async orgUsage(requestParameters: OrgUsageRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OrgUsageResponse> {
        const response = await this.orgUsageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get list of users in an org.
     */
    async teamUsersListRaw(requestParameters: TeamUsersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OrgUser>>> {
        if (requestParameters['orgId'] == null) {
            throw new runtime.RequiredError(
                'orgId',
                'Required parameter "orgId" was null or undefined when calling teamUsersList().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/api/orgs/{org_id}/users/`.replace(`{${"org_id"}}`, encodeURIComponent(String(requestParameters['orgId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OrgUserFromJSON));
    }

    /**
     * Get list of users in an org.
     */
    async teamUsersList(requestParameters: TeamUsersListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OrgUser>> {
        const response = await this.teamUsersListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async userInvitationsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserInvitationsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/orgs/api/user-invitations/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserInvitationsResponseFromJSON(jsonValue));
    }

    /**
     */
    async userInvitations(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserInvitationsResponse> {
        const response = await this.userInvitationsRaw(initOverrides);
        return await response.value();
    }

}
